import { useEffect } from 'react'

import WORDING from 'constants/wording'

import { trackEvent } from 'analytics/trackFunctions'

import PageWrapper from 'components/PageWrapper'
import CardTabs from './components/CardTabs'

const { MY_CARDS } = WORDING

const MyCard = () => {
  useEffect(() => {
    trackEvent({ eventName: 'bille_pantalla_tarjeta' })
  }, [])

  return (
    <PageWrapper isSectionHome title={MY_CARDS}>
      <section className='md:max-w-2xl w-full mx-auto text-black'>
        <CardTabs />
      </section>
    </PageWrapper>
  )
}
export default MyCard
